/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * Labels for request field names and their selectable options, in pt. Importing this module
 * registers them and re-renders every mounted form, exactly like the chrome catalogue beside it.
 * Regenerate with `bun run generate`; the source of truth is the API, not this file.
 */

import { registerFieldLabels } from '../../i18n/registry.js';

registerFieldLabels('pt', {
	fields: {
		allowDuplicates: 'Permitir cartas duplicadas',
		allowReversals: 'Permitir cartas invertidas',
		antardasha: 'Antardasha',
		approximateDate: 'Data aproximada',
		arcana: 'Arcano',
		aspectTypes: 'Tipos de aspecto',
		avasthaInfo: 'Include avastha details',
		ayanamsa: 'Ayanamsa',
		ayanamsaValue: 'Valor de ayanamsa personalizado',
		biorhythm: 'Biorritmo',
		birthData: 'Dados de nascimento',
		birthDate: 'Data de nascimento',
		birthLatitude: 'Latitude de nascimento',
		birthLongitude: 'Longitude de nascimento',
		birthTime: 'Hora de nascimento',
		chakra: 'Chakra',
		color: 'Cor',
		context: 'Onde viu',
		coordinateSystem: 'Sistema de coordenadas',
		count: 'Quantidade',
		currentYear: 'Ano',
		date: 'Data',
		datetime: 'Data e hora',
		day: 'Dia',
		division: 'Carta divisional',
		domainWeights: 'Pesos dos domínios',
		domains: 'Domínios',
		element: 'Elemento',
		endDate: 'Data final',
		endDatetime: 'Data e hora final',
		expression: 'Número de Expressão',
		family: 'Yoga family',
		focus: 'Foco',
		fullName: 'Nome completo',
		horaryNumber: 'Horary number',
		houseSystem: 'Sistema de casas',
		id: 'ID',
		include: 'Corpos adicionais',
		interpretation: 'Significado da posição',
		intervalMinutes: 'Intervalo em minutos',
		iso2: 'Código do país',
		lang: 'Idioma',
		latitude: 'Latitude',
		letter: 'Letra inicial',
		lifePath: 'Número do Caminho de Vida',
		limit: 'Resultados por página',
		lines: 'Padrão de linhas',
		longitude: 'Longitude',
		mahadasha: 'Mahadasha',
		members: 'Membros do grupo',
		minSignificance: 'Significância mínima',
		minStrength: 'Força mínima',
		modernPlanets: 'Incluir planetas modernos',
		month: 'Mês',
		name: 'Nome',
		natalChart: 'Mapa natal',
		nodeType: 'Tipo de nó lunar',
		number: 'Número',
		offset: 'Resultados a ignorar',
		orb: 'Orbe',
		person1: 'Pessoa 1',
		person2: 'Pessoa 2',
		personA: 'Pessoa A',
		personB: 'Pessoa B',
		planet: 'Planeta',
		planets: 'Planetas',
		positions: 'Posições da tiragem',
		pratyantardasha: 'Pratyantardasha',
		q: 'Pesquisa',
		question: 'A sua pergunta',
		relocationLatitude: 'Latitude de relocação',
		relocationLongitude: 'Longitude de relocação',
		returnDate: 'Data de retorno',
		returnYear: 'Ano de retorno',
		scheme: 'Esquema de karakas',
		seed: 'Semente',
		sign: 'Signo do zodíaco',
		significators: 'Incluir significadores KP',
		sookshma: 'Sookshma',
		soulUrge: 'Número do Desejo da Alma',
		spreadName: 'Nome da tiragem',
		startDate: 'Data inicial',
		startDatetime: 'Data e hora inicial',
		strictOrbs: 'Usar orbes mais estreitos',
		suit: 'Naipe',
		system: 'Avastha system',
		targetDate: 'Data alvo',
		targetMonth: 'Mês alvo',
		time: 'Hora',
		timezone: 'Fuso horário',
		top: 'Principais eventos por janela',
		transitDate: 'Data de trânsito',
		transitTime: 'Hora de trânsito',
		type: 'Tipo de padrão',
		vedic: 'Védica',
		western: 'Ocidental',
		year: 'Ano',
		zodiac: 'Signo do zodíaco',
	},
	enums: {
		'arcana.major': 'Arcano Maior',
		'arcana.minor': 'Arcano Menor',
		'ayanamsa.custom': 'Personalizado',
		'ayanamsa.kp-newcomb': 'KP Newcomb',
		'ayanamsa.kp-old': 'KP Old',
		'ayanamsa.lahiri': 'Lahiri',
		'ayanamsa.raman': 'B.V. Raman',
		'chakra.Crown': 'Coroa',
		'chakra.Heart': 'Coração',
		'chakra.Root': 'Raiz',
		'chakra.Sacral': 'Sacral',
		'chakra.Solar Plexus': 'Plexo Solar',
		'chakra.Third Eye': 'Terceiro Olho',
		'chakra.Throat': 'Garganta',
		'context.address': 'Endereço',
		'context.clock': 'Relógio',
		'context.license-plate': 'Placa',
		'context.phone': 'Telefone',
		'context.price': 'Preço',
		'context.receipt': 'Recibo',
		'coordinateSystem.sidereal': 'Sideral',
		'coordinateSystem.tropical': 'Tropical',
		'element.Air': 'Ar',
		'element.Earth': 'Terra',
		'element.Fire': 'Fogo',
		'element.Storm': 'Tempestade',
		'element.Water': 'Água',
		'family.akriti': 'Akriti',
		'family.asraya': 'Asraya',
		'family.classical': 'Classical',
		'family.dala': 'Dala',
		'family.sankhya': 'Sankhya',
		'focus.finance': 'Finanças',
		'focus.general': 'Geral',
		'houseSystem.equal': 'Iguais',
		'houseSystem.koch': 'Koch',
		'houseSystem.placidus': 'Placidus',
		'houseSystem.whole-sign': 'Signo Inteiro',
		'lang.de': 'Alemão',
		'lang.en': 'Inglês',
		'lang.es': 'Espanhol',
		'lang.fr': 'Francês',
		'lang.hi': 'Hindi',
		'lang.pt': 'Português',
		'lang.ru': 'Russo',
		'lang.tr': 'Turco',
		'nodeType.mean': 'Nó médio',
		'nodeType.true': 'Nó verdadeiro',
		'planet.Jupiter': 'Júpiter',
		'planet.Mars': 'Marte',
		'planet.Mercury': 'Mercúrio',
		'planet.Saturn': 'Saturno',
		'planet.Venus': 'Vênus',
		'scheme.eight': 'Oito karakas',
		'scheme.seven': 'Sete karakas',
		'suit.cups': 'Copas',
		'suit.pentacles': 'Ouros',
		'suit.swords': 'Espadas',
		'suit.wands': 'Paus',
		'system.baladi': 'Baladi',
		'system.deeptadi': 'Deeptadi',
		'system.jagradadi': 'Jagradadi',
		'type.compound': 'Composto',
		'type.master': 'Mestre',
		'type.mirror': 'Espelho',
		'type.repeating': 'Repetido',
		'type.root': 'Raiz',
		'type.sequential': 'Sequencial',
		'zodiac.aquarius': 'Aquário',
		'zodiac.aries': 'Áries',
		'zodiac.cancer': 'Câncer',
		'zodiac.capricorn': 'Capricórnio',
		'zodiac.gemini': 'Gêmeos',
		'zodiac.leo': 'Leão',
		'zodiac.libra': 'Libra',
		'zodiac.pisces': 'Peixes',
		'zodiac.sagittarius': 'Sagitário',
		'zodiac.scorpio': 'Escorpião',
		'zodiac.taurus': 'Touro',
		'zodiac.virgo': 'Virgem',
	},
});
